module.exports = __webpack_public_path__ + "static/media/PlusCircleOutlined.d66ac61d.svg";